﻿
export namespace UrlHelper {

    export function onOpenUrlHandler(url: string): void {
        if (url && url.length > 0) {
            window.location.href = url;
        }
    }

}
